module.exports = __webpack_public_path__ + "static/media/book-solid.6205ece5.svg";